import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "panel-sidebar-collapsed"

export default class extends Controller {
  connect() {
    if (localStorage.getItem(STORAGE_KEY) === "true") {
      this.element.classList.add("is-collapsed")
    }
  }

  toggle() {
    const collapsed = this.element.classList.toggle("is-collapsed")
    localStorage.setItem(STORAGE_KEY, collapsed)
  }
}
